import { apiService } from './api';

// Read-only client for admin-api /api/admin/template-prices.

export interface TemplatePriceRow {
    marketType: string;
    probability: number;
    price: number;
}

export const templatePriceService = {
    // Template price sets (margin levels) currently loaded on the backend.
    getLevels: async (): Promise<string[]> => {
        const levels = await apiService.get<string[]>('/template-prices/levels');
        return [...levels].sort();
    },

    getPrices: async (marginLevel: string): Promise<TemplatePriceRow[]> => {
        const encoded = encodeURIComponent(marginLevel);
        return apiService.get<TemplatePriceRow[]>(`/template-prices?marginLevel=${encoded}`);
    }
};
